export default {"src":"/_next/static/media/julia.c330fbca.svg","height":330,"width":512,"blurWidth":0,"blurHeight":0};